import { Tabs, Tab } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link, matchPath, useLocation, useParams } from 'react-router-dom';
import { RoutesEnum } from 'src/shared/models/enums/routes.enum';

const useRouteMatch = (patterns: readonly string[]) => {
  const { pathname } = useLocation();

  for (let i = 0; i < patterns.length; i += 1) {
    const pattern = patterns[i];
    const possibleMatch = matchPath(pattern, pathname);
    if (possibleMatch !== null) {
      return possibleMatch;
    }
  }

  return null;
};

export default function AdminInvoiceGroupTabNavigation() {
  const { t } = useTranslation(['invoice']);
  const { id } = useParams();
  const routeMatch = useRouteMatch([`${RoutesEnum.AdminInvoiceGroupSettings}/:id/accounting`, `${RoutesEnum.AdminInvoiceGroupSettings}/:id`]);

  if (!id) return null;

  const base = `${RoutesEnum.AdminInvoiceGroupSettings}/${id}`;
  const tabs = [
    { label: 'invoice:adminInvoiceGroupDetailPage.paymentMethods', route: base },
    { label: 'invoice:adminInvoiceGroupDetailPage.accounting', route: `${base}/accounting` },
  ];

  const currentTab = routeMatch?.pattern?.path?.includes('accounting') ? `${base}/accounting` : base;

  return (
    <Tabs value={currentTab}>
      {tabs.map((item) => (
        <Tab label={t(item.label)} key={item.route} value={item.route} to={item.route} component={Link} />
      ))}
    </Tabs>
  );
}
